import findOcppConfig from '../../lib/findOcppConfig'
import { isConfigReadonly } from '../../lib/is-config-readonly'
import { IConfigKey } from '../../lib/loadOcppConfigKeys'
import SEMANTIC_VERSIONING_REGEX from '../constants/SemanticVersioning'
import { KeyValue } from '../redux/api/web-api'

export function serialize(obj: unknown, capitalize?: boolean) {
    const str = []
    for (const p in obj)
        if (Object.prototype.hasOwnProperty.call(obj, p) && typeof obj[p] !== 'undefined') {
            let p1 = p
            if (capitalize) p1 = p.charAt(0).toUpperCase() + p.slice(1)

            str.push(encodeURIComponent(p1) + '=' + encodeURIComponent(obj[p]))
        }
    return str.join('&')
}

export function capitalize(text: string) {
    return text.charAt(0).toUpperCase() + text.slice(1)
}

//convert Fw version to number
export const getFirmwareVersion = (configKeys: IConfigKey[] | undefined): string => {
    const firmwareVersionConfig = findOcppConfig('FirmwareVersion', configKeys)
    const fwVersionKey = firmwareVersionConfig?.match(SEMANTIC_VERSIONING_REGEX)
    const fwVersion = fwVersionKey ? fwVersionKey[0] : firmwareVersionConfig ?? '0'
    const versionNumber = fwVersion.slice(0, 5)
    return versionNumber
}

//Semantic version comparison

export const compareSemanticVersions = (version1: string | number, version2: string | number): boolean => {
    if (version1 && version2) {
        const v1Components = version1?.toString().split('.').map(Number)
        const v2Components = version2?.toString().split('.').map(Number)

        // Handle cases where version1 or version2 are undefined or empty
        if (!v1Components || !v2Components) {
            return false
        }

        // Make the version arrays the same length by padding with zeros
        while (v1Components.length < v2Components.length) {
            v1Components.push(0)
        }
        while (v2Components.length < v1Components.length) {
            v2Components.push(0)
        }

        // Compare each component of the version numbers
        for (let i = 0; i < Math.max(v1Components.length, v2Components.length); i++) {
            if (v1Components[i] > v2Components[i]) {
                return true
            } else if (v1Components[i] < v2Components[i]) {
                return false
            }
            // If they are equal, continue to the next component
        }
    }
    // If all components are equal, return false
    return false
}

export const earthingSystemReadOnly = (configKeys: KeyValue[] | undefined | null) => {
    return isConfigReadonly('EarthingSystem', configKeys)
}

export const pad = (toPad: string, isReverse: boolean) => {
    let retVal
    let toAdd
    if (toPad.length <= 8) {
        toAdd = 8 - toPad.length
    } else if (toPad.length <= 14) {
        toAdd = 14 - toPad.length
    } else if (toPad.length <= 20) {
        toAdd = 20 - toPad.length
    } else {
        toAdd = toPad.length % 2
    }
    if (isReverse) {
        retVal = toPad + '0'.repeat(toAdd)
    } else {
        retVal = '0'.repeat(toAdd) + toPad
    }
    return retVal
}

export const reverseHex = (hex: string) => {
    const match = hex.match(/[a-fA-F0-9]{2}/g)
    if (match === null) {
        return ''
    }
    return match.reverse().join('')
}
